import { useNavigate, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";

export default function ResponseCompletePage() {
  const navigate = useNavigate();
  const location = useLocation();
  const txHash = location.state?.txHash;
  const contractSurveyId = location.state?.contractSurveyId;

  return (
    <div className="max-w-md mx-auto text-center py-12">
      <div className="card">
        <div className="mb-6">
          <svg className="w-20 h-20 text-green-400 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>

        <h1 className="text-3xl font-bold text-gray-100 mb-4">Vote Submitted On-Chain!</h1>

        <p className="text-gray-400 mb-6">
          Your vote has been recorded on the blockchain. Thank you for participating!
        </p>

        {txHash && (
          <div className="bg-green-500/10 border border-green-500/20 rounded-lg p-4 mb-6">
            <p className="text-green-400 text-sm font-medium mb-2">🎉 Vote Confirmed On-Chain!</p>
            <p className="text-gray-400 text-xs break-all mb-2">
              Transaction Hash: {txHash}
            </p>
            <p className="text-gray-500 text-xs">
              Your vote is permanently recorded on the blockchain and can be verified on-chain.
            </p>
          </div>
        )}

        <div className="bg-blue-500/10 border border-blue-500/20 rounded-lg p-4 mb-6">
          <p className="text-blue-300 text-sm">
            💰 If your choice wins, you'll receive a share of the reward distribution after the survey ends.
            Rewards are distributed via smart contract to majority voters.
          </p>
        </div>

        <Link to="/surveys" className="btn btn-primary block w-full">
          View More Surveys
        </Link>
      </div>
    </div>
  );
}
